import {createAsyncThunk} from '@reduxjs/toolkit';
import getStarRatings from 'api/facilities/get-star-ratings';
import {StarRatingsResponse} from './starRatings.types';

interface Period {
    value: number;
    unit: string;
}
interface GetStarRatingsParams {
    facilityId: number;
    selectedPeriodObject: Period;
}

/**
 * Fetches the star ratings data for a given facility.
 *
 * This thunk action creator makes an asynchronous call to the API to retrieve
 * the star ratings data for the specified facility and period.
 *
 * Action Type: 'facilities/getStarRatingsData'
 *
 * API Service: {@link getStarRatings}
 */
export const getStarRatingsData = createAsyncThunk<
    StarRatingsResponse,
    GetStarRatingsParams
>(
    'facilities/getStarRatingsData',
    async ({facilityId, selectedPeriodObject}, {rejectWithValue}) => {
        try {
            const response = await getStarRatings(
                facilityId,
                selectedPeriodObject
            );

            return response;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
